import { all } from 'redux-saga/effects';
import { authSagas } from './authSagas';
import { experienceSagas } from './experienceSagas';

export function* rootSaga() {
  yield all([...authSagas, ...experienceSagas]);
}
